import React from 'react';
import { Clock, BatteryWarning, ShoppingCart, Frown } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-white" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-112">
            Llegas del trabajo. Estás cansado. Tienes hambre.
          </h2>
          <p className="text-lg text-stone-600 leading-relaxed" data-id="element-113">
            Abres el refri… y empieza el mismo juego: "¿Qué hago?", "¿Tengo
            algo?", "¿Pido delivery?". Tomar esa decisión todos los días te está
            drenando.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-114">
          {[{
          icon: Clock,
          title: 'Falta de Tiempo',
          desc: 'Llegas sin energía y la idea de cocinar se siente como una tarea imposible.'
        }, {
          icon: BatteryWarning,
          title: 'Carga Mental',
          desc: 'El problema no es cocinar, es decidir qué hacer con el cerebro ya gastado.'
        }, {
          icon: ShoppingCart,
          title: 'Compras Caóticas',
          desc: 'Compras sin orden, gastas de más y los ingredientes se pudren en el refri.'
        }, {
          icon: Frown,
          title: 'Culpa Constante',
          desc: 'Terminas pidiendo delivery caro y poco saludable, sintiéndote mal después.'
        }].map((item, idx) => <div key={idx} className="bg-stone-50 p-6 rounded-2xl border border-stone-100 hover:border-red-100 transition-colors" data-id="element-115">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4 text-red-700" data-id="element-116">
                <item.icon className="h-6 w-6" data-id="element-117" />
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2" data-id="element-118">
                {item.title}
              </h3>
              <p className="text-stone-600 text-sm" data-id="element-119">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}